module.exports = __webpack_public_path__ + "static/media/ios-calculator.d02588d1.svg";